import React, { useState, useEffect } from 'react';
import TaskDropdown from './taskDropdown';
import { apiFetch } from './api';

const Wochenplan = ({ user, reloadSignal, onReload }) => {
  const [wochenOffset, setWochenOffset] = useState(0);
  const [eintraege, setEintraege] = useState([]);
  const [popup, setPopup] = useState(null);
  const [name, setName] = useState('');
  const [taskId, setTaskId] = useState(null);
  const [taskName, setTaskName] = useState('');
  const [startStr, setStartStr] = useState('');
  const [endStr, setEndStr] = useState('');
  const [editName, setEditName] = useState('');
  const [editStart, setEditStart] = useState('');
  const [editEnd, setEditEnd] = useState('');
  const [editTaskId, setEditTaskId] = useState(null);
  const [editTaskName, setEditTaskName] = useState('');

  const STUNDE_HOEHE = 44;

  const getMontag = (offset) => {
    const heute = new Date();
    const tag = heute.getDay();
    const diffZuMontag = (tag === 0 ? -6 : 1 - tag);
    const montag = new Date(heute);
    montag.setDate(heute.getDate() + diffZuMontag + offset * 7);
    montag.setHours(0, 0, 0, 0);
    return montag;
  };

  const montag = getMontag(wochenOffset);
  const wochenTage = Array.from({ length: 7 }, (_, i) => {
    const d = new Date(montag);
    d.setDate(montag.getDate() + i);
    return d;
  });
  const tagNamen = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];

  const ladeEintraege = async () => {
    const von = new Date(montag); von.setHours(0, 0, 0, 0);
    const bis = new Date(montag); bis.setDate(montag.getDate() + 7); bis.setHours(0, 0, 0, 0);
    const res = await apiFetch(
      `/zeit/eintraege?user_id=${user.id}&von=${von.toISOString()}&bis=${bis.toISOString()}`
    );
    if (!res) return;
    const data = await res.json();
    setEintraege(Array.isArray(data) ? data : []);
  };

  useEffect(() => { ladeEintraege(); }, [wochenOffset, reloadSignal]);

  const formatDatum = (d) => `${d.getDate()}.${d.getMonth() + 1}.`;

  const istHeute = (d) => {
    const h = new Date();
    return d.getDate() === h.getDate() && d.getMonth() === h.getMonth() && d.getFullYear() === h.getFullYear();
  };

  const zelleKlick = (tagDate, stunde) => {
    const start = new Date(tagDate);
    start.setHours(stunde, 0, 0, 0);
    const end = new Date(start);
    end.setHours(stunde + 1);
    setPopup({ tagDate });
    setStartStr(toLocalInput(start));
    setEndStr(toLocalInput(end));
    setName(''); setTaskId(null); setTaskName('');
  };

  const viewOeffnen = (e) => {
    setPopup({ view: e });
    setEditName(e.name || '');
    setEditStart(toLocalInput(new Date(e.start_zeit)));
    setEditEnd(toLocalInput(new Date(e.end_zeit)));
    setEditTaskId(e.task_id || null);
    setEditTaskName(e.task_name || '');
  };

  const toLocalInput = (d) => {
    const p = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
  };

  const speichern = async () => {
    if (!taskId && !name) { alert('Bitte eine Task auswählen oder eine Beschreibung eingeben'); return; }
    if (!startStr || !endStr) { alert('Bitte Start und Ende angeben'); return; }
    await apiFetch('/zeit/eintraege', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name, task_id: taskId || null, user_id: user.id,
        start_zeit: new Date(startStr).toISOString(),
        end_zeit: new Date(endStr).toISOString()
      })
    });
    setPopup(null);
    ladeEintraege();
    if (onReload) onReload();
  };

  const editSpeichern = async () => {
    await apiFetch(`/zeit/eintraege/${popup.view.id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name: editName,
        task_id: editTaskId || null,
        start_zeit: new Date(editStart).toISOString(),
        end_zeit: new Date(editEnd).toISOString()
      })
    });
    setPopup(null);
    ladeEintraege();
    if (onReload) onReload();
  };

  const eintragLoeschen = async (id) => {
    await apiFetch(`/zeit/eintraege/${id}`, { method: 'DELETE' });
    setPopup(null);
    ladeEintraege();
    if (onReload) onReload();
  };

  const eintragStyle = (e) => {
    const start = new Date(e.start_zeit);
    const top = (start.getHours() + start.getMinutes() / 60) * STUNDE_HOEHE;
    const hoehe = Math.max(18, (e.minuten / 60) * STUNDE_HOEHE);
    return { top: `${top}px`, height: `${hoehe}px` };
  };

  const tagIndexVon = (e) => {
    const d = new Date(e.start_zeit);
    d.setHours(0, 0, 0, 0);
    return Math.round((d - montag) / 86400000);
  };

  const textFarbe = (hex) => {
    if (!hex) return '#1a1a1a';
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    const helligkeit = (r * 299 + g * 587 + b * 114) / 1000;
    return helligkeit > 140 ? '#1a1a1a' : '#ffffff';
  };

  return (
    <div style={{ marginTop: '40px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
        <p style={{ fontSize: '11px', fontWeight: '500', color: '#9b9b9b', textTransform: 'uppercase', letterSpacing: '0.5px', margin: 0 }}>
          Wochenplan
        </p>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <button onClick={() => setWochenOffset(wochenOffset - 1)} style={navBtn}>←</button>
          <span style={{ fontSize: '13px', color: '#6b6b6b', minWidth: '140px', textAlign: 'center' }}>
            {formatDatum(wochenTage[0])} – {formatDatum(wochenTage[6])}
            {wochenOffset === 0 && ' (diese Woche)'}
          </span>
          <button onClick={() => setWochenOffset(wochenOffset + 1)} style={navBtn}>→</button>
        </div>
      </div>

      <div style={{ backgroundColor: '#ffffff', border: '1px solid #efefef', borderRadius: '12px', overflow: 'hidden' }}>
        <div style={{ display: 'flex', borderBottom: '1px solid #efefef' }}>
          <div style={{ width: '48px', flexShrink: 0 }} />
          {wochenTage.map((d, i) => (
            <div key={i} style={{ flex: 1, textAlign: 'center', padding: '10px 4px', borderLeft: '1px solid #f4f4f4' }}>
              <div style={{ fontSize: '11px', color: '#9b9b9b', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{tagNamen[i]}</div>
              <div style={{
                fontSize: '14px', fontWeight: '600', color: istHeute(d) ? '#1a1a1a' : '#6b6b6b', marginTop: '2px',
                ...(istHeute(d) ? { backgroundColor: '#f0f0ee', borderRadius: '12px', display: 'inline-block', padding: '0 8px' } : {})
              }}>{d.getDate()}</div>
            </div>
          ))}
        </div>

        <div style={{ display: 'flex', maxHeight: '520px', overflowY: 'auto' }}>
          <div style={{ width: '48px', flexShrink: 0 }}>
            {Array.from({ length: 24 }, (_, h) => (
              <div key={h} style={{
                height: `${STUNDE_HOEHE}px`, fontSize: '10px', color: '#c4c4c4',
                textAlign: 'right', paddingRight: '6px', paddingTop: '2px', boxSizing: 'border-box'
              }}>{String(h).padStart(2, '0')}:00</div>
            ))}
          </div>

          {wochenTage.map((tagDate, tagIdx) => (
            <div key={tagIdx} style={{ flex: 1, position: 'relative', borderLeft: '1px solid #f4f4f4' }}>
              {Array.from({ length: 24 }, (_, h) => (
                <div key={h} onClick={() => zelleKlick(tagDate, h)} style={{
                  height: `${STUNDE_HOEHE}px`, borderBottom: '1px solid #f7f7f5',
                  cursor: 'pointer', boxSizing: 'border-box'
                }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#fafafa'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                />
              ))}

              {eintraege.filter(e => tagIndexVon(e) === tagIdx).map(e => {
                const ohneTask = !e.task_id;
                const bg = ohneTask ? '#e8e8e8' : (e.mutter_farbe || '#1a1a1a');
                const tc = ohneTask ? '#6b6b6b' : textFarbe(bg);
                return (
                  <div key={e.id} onClick={(ev) => { ev.stopPropagation(); viewOeffnen(e); }} style={{
                    position: 'absolute', left: '2px', right: '2px',
                    ...eintragStyle(e),
                    backgroundColor: bg,
                    border: ohneTask ? '1px dashed #c4c4c4' : 'none',
                    borderRadius: '6px', padding: '3px 6px', fontSize: '10px',
                    overflow: 'hidden', cursor: 'pointer', boxSizing: 'border-box',
                    color: tc
                  }}>
                    <div style={{ fontWeight: '600', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {e.name || e.task_name || '–'}
                    </div>
                    {!ohneTask && (
                      <div style={{ opacity: 0.8, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '9px' }}>
                        {e.projekt_name}
                      </div>
                    )}
                    {ohneTask && (
                      <div style={{ opacity: 0.6, fontSize: '9px' }}>Keine Task</div>
                    )}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>

      {popup && (
        <div onClick={() => setPopup(null)} style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.35)', display: 'flex',
          alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px'
        }}>
          <div onClick={(e) => e.stopPropagation()} style={{
            backgroundColor: '#fff', borderRadius: '14px', width: '100%', maxWidth: '420px',
            padding: '28px', boxShadow: '0 12px 48px rgba(0,0,0,0.18)',
            borderTop: popup.view?.mutter_farbe ? `4px solid ${popup.view.mutter_farbe}` : '4px solid #e8e8e8'
          }}>
            {popup.view ? (
              <>
                <p style={{ fontSize: '11px', fontWeight: '500', color: popup.view.mutter_farbe || '#9b9b9b', textTransform: 'uppercase', letterSpacing: '0.5px', margin: '0 0 4px 0' }}>
                  {popup.view.mutter_name || popup.view.projekt_name || 'Kein Bereich'}
                </p>
                <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#1a1a1a', margin: '0 0 16px 0' }}>
                  {popup.view.name || popup.view.task_name || '– kein Name –'}
                </h3>

                <div style={{ marginBottom: '12px' }}>
                  <label style={labelStyle}>Beschreibung</label>
                  <input type="text" value={editName} onChange={(e) => setEditName(e.target.value)} style={inputStyle} />
                </div>

                <div style={{ marginBottom: '12px' }}>
                  <label style={labelStyle}>Task (optional)</label>
                  <TaskDropdown
                    selectedTaskId={editTaskId}
                    selectedTaskName={editTaskName}
                    onSelect={(id, tname) => { setEditTaskId(id); setEditTaskName(tname); }}
                  />
                </div>

                <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
                  <div style={{ flex: 1 }}>
                    <label style={labelStyle}>Von</label>
                    <input type="datetime-local" value={editStart} onChange={(e) => setEditStart(e.target.value)} style={inputStyle} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={labelStyle}>Bis</label>
                    <input type="datetime-local" value={editEnd} onChange={(e) => setEditEnd(e.target.value)} style={inputStyle} />
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button onClick={editSpeichern} style={{
                    padding: '8px 16px', backgroundColor: '#1a1a1a', color: '#fff', border: 'none',
                    borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer'
                  }}>Speichern</button>
                  <button onClick={() => eintragLoeschen(popup.view.id)} style={{
                    padding: '8px 16px', backgroundColor: 'transparent', border: '1px solid #ffdddd',
                    borderRadius: '8px', fontSize: '13px', color: '#cc0000', cursor: 'pointer'
                  }}>Löschen</button>
                  <button onClick={() => setPopup(null)} style={{
                    padding: '8px 16px', backgroundColor: 'transparent', border: '1px solid #e8e8e8',
                    borderRadius: '8px', fontSize: '13px', color: '#6b6b6b', cursor: 'pointer'
                  }}>Abbrechen</button>
                </div>
              </>
            ) : (
              <>
                <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#1a1a1a', margin: '0 0 20px 0' }}>
                  Neuer Zeiteintrag
                </h3>
                <div style={{ marginBottom: '14px' }}>
                  <label style={labelStyle}>Beschreibung</label>
                  <input type="text" value={name} onChange={(e) => setName(e.target.value)}
                    placeholder="Pflicht wenn keine Task" style={inputStyle} />
                </div>
                <div style={{ marginBottom: '14px' }}>
                  <label style={labelStyle}>Task (optional)</label>
                  <TaskDropdown selectedTaskId={taskId} selectedTaskName={taskName}
                    onSelect={(id, tname) => { setTaskId(id); setTaskName(tname); }} />
                </div>
                <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
                  <div style={{ flex: 1 }}>
                    <label style={labelStyle}>Von</label>
                    <input type="datetime-local" value={startStr} onChange={(e) => setStartStr(e.target.value)} style={inputStyle} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={labelStyle}>Bis</label>
                    <input type="datetime-local" value={endStr} onChange={(e) => setEndStr(e.target.value)} style={inputStyle} />
                  </div>
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button onClick={speichern} style={{
                    padding: '9px 20px', backgroundColor: '#1a1a1a', color: '#fff', border: 'none',
                    borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer'
                  }}>Speichern</button>
                  <button onClick={() => setPopup(null)} style={{
                    padding: '9px 20px', backgroundColor: 'transparent', color: '#6b6b6b',
                    border: '1px solid #e8e8e8', borderRadius: '8px', fontSize: '13px', cursor: 'pointer'
                  }}>Abbrechen</button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const navBtn = {
  width: '30px', height: '30px', borderRadius: '6px', border: '1px solid #e8e8e8',
  backgroundColor: 'transparent', color: '#6b6b6b', cursor: 'pointer', fontSize: '14px'
};
const labelStyle = {
  display: 'block', fontSize: '11px', fontWeight: '500', color: '#6b6b6b',
  marginBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px'
};
const inputStyle = {
  width: '100%', padding: '9px 12px', fontSize: '13px', border: '1px solid #e8e8e8',
  borderRadius: '8px', outline: 'none', boxSizing: 'border-box'
};

export default Wochenplan;